import React from "react";
import {
  View,
  StyleSheet,
  Linking,
  TouchableOpacity,
  Alert,
} from "react-native";
import Share from "react-native-share";
import Caret from "@assets/svg/Caret";
import Text from "@components/AppText";
import { CUSTOMER_PAGE } from "@constants/analyticsEventsCT";
import analytics from "@services/analytics";
import OverlayView from "@components/OverlayView";
import color from "@constants/color";
import t from "@constants/localization";
import Speed from "../../assets/svg/Speed";
import { verticalScale, scale } from "../../utils/scale";
import New from "../../assets/svg/New";
import UpSpeed from "../../assets/svg/UpSpeed";

const PATH = "screens/YourStore/CustomerListItem";
const PATH2 = "WhatsAppAlert";

export function CustomerListItem(props) {
  const {
    isNew,
    connectedByCm,
    name,
    mobile,
    onPress,
    cx_trend,
    appShare,
    isClSuspended,
  } = props || {};
  const shareCXAppLink = async () => {
    const { isInstalled: haveWhatsApp } =
      await Share.isPackageInstalled("com.whatsapp");
    if (!haveWhatsApp) {
      Alert.alert(
        t(`${PATH2}/title`),
        t(`${PATH2}/message`),
        [
          {
            text: t(`${PATH2}/onCloseText`),
            onClose: () => {},
          },
        ],
        { cancelable: true },
      );
    } else {
      const message = t(`${PATH}/CXAppLinkMsg`, {
        leader: props?.leader,
        link: props?.appShare,
      });
      Linking.openURL(
        `whatsapp://send?text=${message}&phone=+91${props.mobile}`,
      );
      analytics.trackEvent(CUSTOMER_PAGE.CX_PAGE_APP_SHARE, {
        cx_id: props?.user_id,
      });
    }
  };
  return (
    <View style={styles.container}>
      {isClSuspended ? <OverlayView /> : null}
      {isNew && (
        <View style={{ position: "absolute", top: 0 }}>
          <New />
        </View>
      )}
      {connectedByCm && (
        <View style={styles.cmoBox}>
          <Text style={{ fontSize: scale(12), color: color.lightBlack }}>
            {t(`${PATH}/addedByCM`)}
          </Text>
        </View>
      )}
      <TouchableOpacity
        onPress={onPress}
        style={{ width: "100%", height: "auto" }}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text style={styles.textStyle}>{name}</Text>
          <View style={{ marginLeft: scale(5) }}>
            <Caret strokeColor={color.primary} width={25} height={25} />
          </View>
        </View>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <Text style={styles.phoneTextStyle}>{mobile}</Text>
          {cx_trend == "NONE" ? null : cx_trend == "UP" ? (
            <View style={{ marginLeft: scale(5) }}>
              <UpSpeed />
            </View>
          ) : (
            <View style={{ marginLeft: scale(5) }}>
              <Speed />
            </View>
          )}
        </View>
      </TouchableOpacity>
      {appShare && (
        <View style={{ flexDirection: "row" }}>
          <Text style={styles.dontHaveAppText}>
            {t(`${PATH}/dontHaveApp`, { name })}
          </Text>
          <TouchableOpacity onPress={() => shareCXAppLink()}>
            <Text style={styles.appShareText}>{t(`${PATH}/shareApp`)}</Text>
          </TouchableOpacity>
          <View style={{ marginLeft: scale(1) }}>
            <Caret strokeColor={color.primary} width={18} height={18} />
          </View>
        </View>
      )}
    </View>
  );
}

export default CustomerListItem;

const styles = StyleSheet.create({
  container: {
    borderBottomWidth: 1,
    borderBottomColor: "rgba(0, 0, 0, 0.1)",
    paddingHorizontal: scale(20),
    paddingVertical: verticalScale(15),
    height: "auto",
    width: "100%",
    backgroundColor: "#FFFFFF",
  },
  textStyle: {
    fontSize: scale(16),
    lineHeight: 22,
    flex: 1,
  },
  phoneTextStyle: {
    fontWeight: "600",
    fontSize: scale(14),
    color: "rgba(0,0,0,.5)",
  },
  dontHaveAppText: {
    fontSize: scale(13),
    color: "rgba(0,0,0,.5)",
    maxWidth: "75%",
  },
  appShareText: {
    marginLeft: scale(5),
    fontSize: scale(13),
    fontWeight: "700",
    color: "#E40046",
  },
  cmoBox: {
    position: "absolute",
    alignItems: "center",
    top: 0,
    right: 0,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    width: scale(115),
    height: verticalScale(18),
    borderTopLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
});
